import React from "react";

import { MenuItem } from "@/custom-types/MenuItem";

import Carousel from "@/components/botanic/Carousel";
import MenuItemCard from "@/components/botanic/MenuItemCard";
import { MenuItemCardActions } from "@/components/Shared/MenuItemCarousel/MenuItemCardActions";

import { Action } from "../../../constants/events";
import { useEventTracker } from "../../../hooks/useEventTracker";

const SimilarMenuItemsCarousel: React.FC<{
  className?: string;
  similarMenuItems?: MenuItem[];
}> = ({ className, similarMenuItems }) => {
  const { publishEvent } = useEventTracker();

  const trackSimilarItemClick = (item: MenuItem) => {
    publishEvent({
      action: Action.click,
      brandId: item?.brand?.id,
      category: "Similar Items Carousel",
      dispensaryId: item?.dispensaryId,
      label: "product card",
      // @ts-ignore -- TODO: Fix publishEvent types (https://leafly.atlassian.net/browse/SHH-1133)
      menuItemId: item?.menuItemId,
      productId: item?.product?.id,
      strainId: item?.strain?.id,
    });
  };

  return similarMenuItems?.length ? (
    <Carousel title="You may also like" className={className}>
      {similarMenuItems.map((item) => (
        <MenuItemCard
          data-testid="product-rec-tray-item"
          handleCardClick={() => trackSimilarItemClick(item)}
          key={item.id}
          menuItem={item}
        >
          <MenuItemCardActions
            menuItem={item}
            onClick={() => trackSimilarItemClick(item)}
          />
        </MenuItemCard>
      ))}
    </Carousel>
  ) : (
    <></>
  );
};

export default SimilarMenuItemsCarousel;
